import { LogoutRedirect } from '../component/account/logout-redirect'
import { FunctionComponent } from 'react'

export const LogoutScreen: FunctionComponent = () => <LogoutRedirect />
